module.exports = __webpack_public_path__ + "static/media/Meezan Credit.40885fd5.m4v";